import { writable } from "svelte/store";
export function createPersistentStore(storageKey, initial) {
    const store = writable(initial);
    try {
        const value = window.localStorage.getItem(storageKey);
        if (value) {
            store.set(JSON.parse(value));
        }
    }
    finally {
        store.subscribe(value => window.localStorage.setItem(storageKey, JSON.stringify(value)));
        return store;
    }
}
